import React, { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowLeft from "./ArrowLeft";
import ArrowRight from "./ArrowRight";
import CalendarIcon from "./CalendarIcon";
import { format, addMonths, subMonths } from "date-fns";
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const CalendarPicker = ({ selectedDate, setSelectedDate }) => {
  const [open, setOpen] = useState(false);

  const isCurrentMonth = (date) => {
    const now = new Date();
    return (
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth()
    );
  };

  const handlePrevMonth = () => {
    if (isCurrentMonth(selectedDate)) return;
    setSelectedDate(subMonths(selectedDate, 1));
  };

  const handleNextMonth = () => {
    setSelectedDate(addMonths(selectedDate, 1));
  };

  return (
    <Box display="flex" alignItems="center" gap="5px">
      <IconButton
        onClick={handlePrevMonth}
        disabled={isCurrentMonth(selectedDate)}
      >
        <ArrowLeft />
      </IconButton>

      <CalendarIcon />

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          sx={{ visibility: 'hidden', width: '1px' }}
          open={open}
          onClose={() => setOpen(false)}
          value={selectedDate}
          onChange={setSelectedDate}
          views={['year', 'month']}
          minDate={new Date()}
        />
      </LocalizationProvider>

      <Typography
        variant="h5"
        sx={{ cursor: 'pointer' }}
        onClick={() => setOpen(true)}
      >
        {format(selectedDate, 'MMMM yyyy')}
      </Typography>

      <IconButton onClick={handleNextMonth}>
        <ArrowRight />
      </IconButton>
    </Box>
  );
};

export default CalendarPicker
